module.exports = __webpack_public_path__ + "c958976f842bcab7c89f258b1cffc447.png";